import React from "react";
import PropTypes from "prop-types";
import { withGetScreen } from "react-getscreen";

import CallToActionButton from "../../layout/CallToActionButton";

import "./styles/PortfolioCard.css";

const PortfolioCard = props => {
  const styles = {
    card: {
      background: `linear-gradient(to right bottom, ${props.colourPrimary}, ${
        props.colourSecondary
      }), url(${props.isMobile() ? props.cardImage2 : props.cardImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    },
    header: {
      background: `linear-gradient(to right bottom, ${props.colourPrimary}, ${
        props.colourSecondary
      })`
    }
  };

  return (
    <div className="card" onClick={props.handlePopup}>
      <div className="card__side card__side--front">
        <div className="card__picture" style={styles.card} />
        <h4 className="card__heading">
          <span className="card__heading-span" style={styles.header}>
            {props.cardHeading}
          </span>
        </h4>
        <div className="card__details">
          <ul>
            {props.cardDetails.map((listItem, i) => (
              <li key={`${props.cardHeading}-${i}`}>{listItem}</li>
            ))}
          </ul>
        </div>
        <div className="call-to-action-container">
          <CallToActionButton
            handleClick={() => {}}
            align="center"
            font_colour={"#ffffff"}
            colourPrimary={props.colourPrimary}
            colourSecondary={props.colourSecondary}
            text={props.buttonText}
          />
        </div>
      </div>
      <div className="card__side card__side--back" style={styles.header}>
        <div className="card__back-content">
          <p className="card__back-content--stack">Tech</p>
          <ul>
            {props.cardStack.map((stackItem, i) => (
              <li key={`${props.cardHeading}--${i}`}>{stackItem}</li>
            ))}
          </ul>
          <CallToActionButton
            handleClick={() => {}}
            align="center"
            font_colour={props.colourPrimary}
            text="See Project"
          />
        </div>
      </div>
    </div>
  );
};

PortfolioCard.defaultProps = {
  colourPrimary: "#fff",
  colourSecondary: "#eee",
  cardNumber: "",
  cardImage: "",
  cardHeading: "",
  cardDetails: [],
  buttonLink: "",
  buttonText: "",
  buttonColour: "",
  cardStack: []
};

PortfolioCard.propTypes = {
  cardImage: PropTypes.string.isRequired,
  cardHeading: PropTypes.string.isRequired,
  cardDetails: PropTypes.array.isRequired,
  buttonLink: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonColour: PropTypes.string.isRequired,
  cardStack: PropTypes.array.isRequired
};

const getScreenOptions = { mobileLimit: 600, tabletLimit: 900 };

export default withGetScreen(PortfolioCard, getScreenOptions);



// WEBPACK FOOTER //
// ./src/components/sections/Section-Portfolio/PortfolioCard.js